import { faqActions } from '@sv-support-sdk/store';

import { faqActions as faqActionsSlices } from '../slices/faq';

export default {
  ...faqActionsSlices,
  ...faqActions,
};
